export const EMAIL_NOT_FOUND_ERROR = 'not_found_in_database'
export const INCORRECT_PASSWORD_ERROR = 'invalid'
export const LAST_ATTEMPT_ERROR = 'last_attempt'
export const LAST_ATTEMPT_FALLBACK = 'Wrong password, 1 attempt left.'
export const LOCKED_ACCOUNT_FALLBACK =
  'Account locked. Try again in a few minutes.'
export const LOCKED_ACCOUNT_ERROR = 'locked'
export const MIN_PASSWORD_LENGTH = 8
export const ENGLISH_LANGUAGE_COUNTRIES = ['uk', 'us', 'au', 'ie', 'nz', 'ca']
export const DUTCH_LANGUAGE_COUNTRIES = ['nl', 'be']
export const GERMAN_LANUAGE_COUNTRIES = ['de', 'at']
export const GOOGLE_LANGUAGE_CODES = new Map([
  ['en', ENGLISH_LANGUAGE_COUNTRIES],
  ['fr', 'fr'],
  ['de', GERMAN_LANUAGE_COUNTRIES],
  ['nl', DUTCH_LANGUAGE_COUNTRIES],
  ['es', 'es'],
  ['it', 'it'],
  ['sv', 'se'],
  ['da', 'dk'],
  ['pl', 'pl'],
  ['zh-CN', 'cn']
])

export const RECAPTCHA_ERROR = 'RECAPTCHA FAILED'
